<template>
  <div class="pa-8">
    <!-- <v-row no-gutters>
      <v-col cols="12" class="px-4 px-sm-8 py-4 index-page">
        <span @click="backToProfile" style="cursor: pointer"
          ><v-icon class="pr-2">mdi-undo-variant</v-icon>ย้อนกลับ</span
        >
      </v-col>
    </v-row> -->
    <v-card
      elevation="1"
      class="pa-4 pa-sm-8 index-page"
      :style="{ borderRadius: '16px 16px 16px 16px' }"
    >
      <v-row no-gutters>
        <v-col cols="12" class="pb-6">
          <v-row class="pb-1" justify="center" align="center">
            <v-col cols="6">
              <h2 class="mb-0" :class="{ 'h2-responsive': true }">
                บรรยากาศการทำงาน
              </h2>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <v-btn
                outlined
                :color="
                  theme === 'KKU_ADMIN' || theme === 'SPU_ADMIN'
                    ? 'bg_primary_register'
                    : 'primary'
                "
                :class="{ 'btn-responsive': true }"
                :style="{
                  backgroundColor: 'white',
                  borderColor:
                    theme === 'KKU_ADMIN' || theme === 'SPU_ADMIN'
                      ? 'var(--v-bg_primary_register-base)'
                      : 'blue',

                  borderRadius: '20px',
                }"
                @click="openModal"
              >
                เพิ่มรูปภาพ/วิดีโอ
              </v-btn>
            </v-col>
          </v-row>

          <!-- Add v-tabs and corresponding v-tab components -->
          <v-tabs v-model="tab">
            <v-tab>รูปภาพ</v-tab>
            <v-tab>วิดีโอ</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-row>
                    <!-- Display loading spinner while loading is true -->
                    <v-col
                      v-if="loading"
                      cols="12"
                      class="d-flex justify-center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-col>

                    <!-- Display images when loading is false -->
                    <template
                      v-else-if="
                        businessMedia.img.some(
                          (image) => image.file_url || image.src
                        )
                      "
                    >
                      <v-col
                        v-for="image in businessMedia.img"
                        :key="image.file_url || image.src"
                        cols="12"
                        md="4"
                      >
                        <v-img
                          v-if="image.file_url || image.src"
                          :src="image.file_url || image.src"
                          :alt="image.file_name || 'Image'"
                          width="350"
                          height="200"
                          contain
                        ></v-img>
                      </v-col>
                    </template>

                    <template v-else>
                      <v-col cols="12" style="text-align: -webkit-center">
                        <v-img
                          src="@/assets/no_news_data.png"
                          :aspect-ratio="$vuetify.breakpoint.xsOnly ? '1' : '4'"
                          contain
                          :width="
                            $vuetify.breakpoint.mdAndUp ? '140px' : '95px'
                          "
                          :height="
                            $vuetify.breakpoint.mdAndUp ? '120px' : '80px'
                          "
                        ></v-img>
                      </v-col>
                      <v-col cols="12" class="text-center">
                        <p style="font-weight: 700">ไม่พบรายการรูปภาพ</p>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-row>
                    <!-- Display loading spinner while loading is true -->
                    <v-col
                      v-if="loading"
                      cols="12"
                      class="d-flex justify-center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-col>

                    <!-- Display videos when loading is false -->
                    <template
                      v-else-if="
                        businessMedia.video.some((video) => video.file_url)
                      "
                    >
                      <v-col
                        v-for="video in businessMedia.video"
                        :key="video.file_url || video.src"
                        cols="12"
                        md="4"
                      >
                        <video
                          v-if="
                            video.file_url &&
                            video.file_name &&
                            video.type === 'attached'
                          "
                          :src="video.file_url"
                          controls
                          width="100%"
                          height="auto"
                        ></video>
                        <iframe
                          v-else-if="
                            video.file_url && video.type === 'embedded'
                          "
                          :src="getYouTubeEmbedURL(video.file_url)"
                          frameborder="0"
                          allowfullscreen
                          width="100%"
                          height="100%"
                          class="media-ratio"
                        ></iframe>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="12" style="text-align: -webkit-center">
                        <v-img
                          src="@/assets/no_news_data.png"
                          :aspect-ratio="$vuetify.breakpoint.xsOnly ? '1' : '4'"
                          contain
                          :width="
                            $vuetify.breakpoint.mdAndUp ? '140px' : '95px'
                          "
                          :height="
                            $vuetify.breakpoint.mdAndUp ? '120px' : '80px'
                          "
                        ></v-img>
                      </v-col>
                      <v-col cols="12" class="text-center">
                        <p style="font-weight: 700">ไม่พบรายการวิดีโอ</p>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>

      <!-- Modal -->
      <v-dialog v-model="isModalVisible" max-width="1000px" style="z-index: 2500;">
        <v-card class="index-page">
          <v-card-title class="text-section">
            เพิ่มรูปภาพ หรือ วิดีโอ
            <v-spacer></v-spacer>
            <v-btn icon @click="closeModal">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <!-- Upload Video Column -->
              <v-col
                cols="12"
                sm="5"
                class="upload-area"
                :style="{
                  opacity:
                    canUploadVideo &&
                    (uploadProgress === 0 || uploadProgress === 100)
                      ? 1
                      : 0.5,
                  pointerEvents:
                    canUploadVideo &&
                    (uploadProgress === 0 || uploadProgress === 100)
                      ? 'auto'
                      : 'none',
                  backgroundColor:
                    isUploadingVideo || businessMedia.video.length > 0
                      ? '#f0f0f0'
                      : 'transparent', // Gray background during upload
                }"
                @dragover.prevent
                @dragenter.prevent="onDragEnter('video')"
                @dragleave="onDragLeave('video')"
                @drop.prevent="handleDrop('video', $event)"
              >
                <div class="text-file-lenght">
                  {{ businessMedia.video.length }} / 1 วิดีโอ
                </div>

                <!-- Hide image on mobile -->
                <v-img
                  class="mb-4 d-none d-sm-block"
                  :src="uploadVideoIcon"
                  height="110px"
                  contain
                ></v-img>

                <!-- Hide text on mobile -->
                <div class="text-address pl-3 py-5 d-none d-sm-block">
                  ลากไฟล์วิดีโอวางที่นี่ หรือ
                </div>
                <p><span>*</span> อัปโหลดไฟล์ได้ ขนาดไม่เกิน 100 MB</p>
                <v-btn
                  outlined
                  class="btn-upload"
                  :disabled="isUploadingVideo || businessMedia.video.length > 0"
                  @click="canUploadVideo && $refs.videoInput.click()"
                >
                  อัปโหลด
                </v-btn>
                <input
                  ref="videoInput"
                  type="file"
                  accept="video/*"
                  multiple
                  style="display: none"
                  @click.stop="triggerFileInput"
                  @change="handleUploadedFiles('video', $event)"
                />
              </v-col>

              <!-- Divider with Text "หรือ" -->
              <v-col
                cols="0"
                sm="2"
                class="d-flex text-center align-center justify-center d-none d-sm-block"
                style="align-content: center"
              >
                <b class="text-detail" style="font-size: 20px">หรือ</b>
              </v-col>

              <!-- Upload Image Column -->

              <v-col
                cols="12"
                sm="5"
                class="upload-area"
                @dragover.prevent
                @dragenter.prevent="onDragEnter('image')"
                @dragleave="onDragLeave('image')"
                @drop.prevent="handleDrop('image', $event)"
              >
                <div class="text-file-lenght">
                  {{ businessMedia.img.length }} รูปภาพ
                </div>

                <v-img
                  class="mb-4 d-none d-sm-block"
                  :src="uploadNewsIcon"
                  height="110px"
                  contain
                ></v-img>

                <div class="text-address py-5 d-none d-sm-block">
                  ลากไฟล์รูปภาพวางที่นี่ หรือ
                </div>
                <p><span>*</span> อัปโหลดไฟล์ได้ ขนาดไม่เกิน 20 MB</p>

                <v-btn
                  outlined
                  class="btn-upload"
                  @click="$refs.imageInput.click()"
                >
                  อัปโหลด
                </v-btn>
                <input
                  ref="imageInput"
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  multiple
                  style="display: none"
                  :disabled="isUploading"
                  @change="handleUploadedImage('image', $event)"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-8">
              <v-col cols="12" sm="5">
                <v-row no-gutters>
                  <v-col cols="12" sm="9">
                    <!-- URL Input for video URL -->
                    <v-text-field
                      :disabled="businessMedia.video.length > 0"
                      v-model="videoUrl"
                      dense
                      outlined
                      rounded
                      hide-details="auto"
                      placeholder="เพิ่มลิงก์ URL"
                      color="default_primary"
                  /></v-col>
                  <v-col cols="12" sm="2" class="pl-0 pl-sm-2 my-2 mt-sm-0">
                    <!-- Upload Button -->
                    <v-btn
                      color="default_primary"
                      @click="handleUploadUrl"
                      style="color: white"
                      rounded
                      :disabled="businessMedia.video.length > 0"
                    >
                      บันทึก
                    </v-btn></v-col
                  >
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters>วีดิโอ สามารถอัปโหลดได้ 1 วีดิโอเท่านั้น</v-row>
            <!-- Display uploaded files -->
            <v-row no-gutters class="ma-4">
              <v-col cols="12" v-if="businessMedia.video.length > 0">
                <h3 class="mb-2">ไฟล์วิดีโอ</h3>
                <v-row
                  no-gutters
                  v-for="(video, index) in businessMedia.video"
                  :key="`vid-${index}`"
                  class="text-left border-box mb-4 hovered-div"
                >
                  <v-col cols="12" sm="auto" style="text-align: -webkit-center">
                    <v-img
                      src="@/assets/upload_success.png"
                      class="file-img"
                    ></v-img>
                  </v-col>
                  <v-col class="text-center text-sm-left pt-2">
                    <span class="pa-sm-4" style="font-size: 18px">
                      <span class="mr-2">{{ video.file_name }}</span
                      ><v-icon
                        color="default_primary"
                        class="icon-hover mb-1"
                        small
                        style="
                          background-color: #f5fff8;
                          border-radius: 50%;
                          padding: 1px;
                          transition: background-color 0.3s, color 0.3s;
                        "
                      >
                        mdi-check
                      </v-icon>
                    </span>
                  </v-col>
                  <v-col
                    style="align-items: right"
                    cols="1"
                    sm="1"
                    md="1"
                    class="pa-0"
                  >
                    <v-btn icon @click="removeFile(index, 'video')">
                      <v-icon class="align-end" color="red"
                        >mdi-delete-outline</v-icon
                      >
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row
                  v-if="isUploadingVideo"
                  no-gutters
                  class="mt-2 text-left border-box mb-4 hovered-div"
                >
                  <v-col cols="auto" class="d-flex align-items-center">
                    <v-img
                      src="@/assets/upload_success.png"
                      class="file-img ml-2"
                    ></v-img>
                  </v-col>
                  <v-col cols="10">
                    <span class="mr-2">{{ filename }}</span>
                    <v-progress-linear
                      :value="uploadProgress"
                      :buffer-value="uploadProgress + 10"
                      height="8"
                      color="default_primary"
                      striped
                      class="mb-2"
                      :indeterminate="isUploadingVideo && uploadProgress === 0"
                    ></v-progress-linear>
                  </v-col>
                  <v-col cols="auto" class="d-flex align-items-center">
                    {{ uploadProgress }} %
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" v-if="businessMedia.img.length > 0">
                <h3 class="mb-2">ไฟล์รูปภาพ</h3>
                <v-row
                  no-gutters
                  v-for="(file, index) in businessMedia.img"
                  :key="`img-${index}`"
                  class="text-left border-box mb-4 hovered-div"
                >
                  <v-col cols="12" sm="auto" style="text-align: -webkit-center">
                    <v-img
                      src="@/assets/upload_success.png"
                      class="file-img"
                    ></v-img>
                  </v-col>
                  <v-col class="text-center text-sm-left pt-2">
                    <span class="pa-sm-4" style="font-size: 18px">
                      <span class="mr-2">{{ file.file_name }}</span
                      ><v-icon
                        color="default_primary"
                        class="icon-hover mb-1"
                        small
                        style="
                          background-color: #f5fff8;
                          border-radius: 50%;
                          padding: 1px;
                          transition: background-color 0.3s, color 0.3s;
                        "
                      >
                        mdi-check
                      </v-icon>
                    </span>
                    <v-row
                      v-if="isUploading"
                      no-gutters
                      justify="center"
                      class="mt-2"
                    >
                      <v-col cols="10">
                        <v-progress-linear
                          :value="uploadProgress"
                          height="8"
                          color="default_primary"
                          striped
                          class="mb-2"
                        ></v-progress-linear>
                      </v-col>
                      <v-col cols="auto" class="d-flex align-items-center">
                        {{ uploadProgress }} %
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    style="align-items: right"
                    cols="1"
                    sm="1"
                    md="1"
                    class="pa-0"
                  >
                    <v-btn icon @click="removeFile(index, 'image')">
                      <v-icon class="align-end" color="red"
                        >mdi-delete-outline</v-icon
                      >
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ImageAndVideoPage",
  props: {
    business_data: {
      type: Object,
      default: () => ({ business_image_urls: [], business_video_urls: [] }),
    },
    showProfileAddSuccess: Boolean,
  },

  data() {
    return {
      isModalVisible: false,
      imageFilesList: [],
      videoFilesList: [],
      isDraggingImage: false,
      isDraggingVideo: false,
      storedImages: [],
      storedVideos: [],
      videoUrl: null,
      uploadProgress: 0,
      isUploading: false,
      isUploadingVideo: false,
      tab: null,
      theme: process.env.VUE_APP_USE_THEME,
      filename: "",
      businessMedia: {
        img: [],
        video: [],
      },
    };
  },
  created() {
    this.fetchBusinessMediaAdmin();
  },
  computed: {
    ...mapGetters({
      position_role: "position_role",
      user: "user",
      business_id: "business_id",
    }),
    hasImages() {
      return this.imageFilesList.length > 0;
    },
    hasVideos() {
      return this.videoFilesList.length > 0;
    },
    canUploadVideo() {
      return this.businessMedia.video.length === 0;
    },
    canUploadImage() {
      return this.imageFilesList.length === 0;
    },
    allImages() {
      return [...this.imageFilesList];
    },
    allVideos() {
      return [...this.videoFilesList];
    },
    uploadVideoIcon() {
      const theme = process.env.VUE_APP_USE_THEME;

      if (theme === "KKU_ADMIN") {
        return require("@/assets/video_upload_kku.png");
      } else if (theme === "SPU_ADMIN") {
        return require("@/assets/video_upload_spu.png");
      } else {
        return require("@/assets/video_upload.png");
      }
    },
    uploadNewsIcon() {
      const theme = process.env.VUE_APP_USE_THEME;

      if (theme === "KKU_ADMIN") {
        return require("@/assets/image_new_upload_kku.png");
      } else if (theme === "SPU_ADMIN") {
        return require("@/assets/image_new_upload_spu.png");
      } else {
        return require("@/assets/image_new_upload.png");
      }
    },
  },
  mounted() {
    this.fetchMedia();
  },
  methods: {
    openModal() {
      this.isModalVisible = true;
    },
    fetchMedia() {
      setTimeout(() => {
        this.businessMedia = {
          img: this.businessMedia.img,
          video: this.businessMedia.video,
        };
        this.loading = false;
      }, 2000); // Simulate loading for 2 seconds
    },
    closeModal() {
      this.isModalVisible = false;
    },
    triggerFileInput() {
      this.$refs.videoInput.value = null; // รีเซ็ตค่า input file
      this.$refs.videoInput.click(); // เปิด dialog เลือกไฟล์ใหม่
    },

    getYouTubeEmbedURL(url) {
      let videoId;
      if (url.includes("youtube.com")) {
        videoId = new URLSearchParams(new URL(url).search).get("v");
      } else if (url.includes("youtu.be")) {
        videoId = url.split("/").pop().split("?")[0];
      }
      return `https://www.youtube-nocookie.com/embed/${videoId}`;
    },

    simulateProgressUpdate(progressEvent) {
      const total = progressEvent.total;
      const loaded = progressEvent.loaded;
      const currentProgress = Math.round((loaded * 100) / total);

      if (this.uploadProgress < currentProgress) {
        const interval = setInterval(() => {
          if (this.uploadProgress < currentProgress) {
            this.uploadProgress += 1;
          } else {
            clearInterval(interval);
          }
        }, 10);
      }
    },

    async handleUploadedImage(type, event) {
      const files = Array.from(event.target.files);

      if (type === "image" && files.length > 0) {
        try {
          for (const file of files) {
            const validExtensions = ["image/jpeg", "image/png"];
            if (!validExtensions.includes(file.type)) {
              this.$store.commit("onAlerting", {
                message_status: "กรุณาอัปโหลดไฟล์เฉพาะ .JPG .JPEG .PNG",
                color: "#D1392B",
              });
              event.target.value = null;
              return;
            }

            // เช็คขนาดไฟล์ไม่เกิน 20MB
            if (file.size > 20 * 1024 * 1024) {
              // 20 MB
              // ส่งการแจ้งเตือนไปยัง Vuex store
              this.$store.commit("onAlerting", {
                message_status: "ไฟล์ภาพใหญ่เกิน 20MB ไม่สามารถอัปโหลดได้",
                color: "#D1392B",
              });
              event.target.value = null; // รีเซ็ตค่า input file
              return; // ออกจากฟังก์ชัน
            }

            let formbody = new FormData();
            formbody.append("image", file); // Ensure this field name matches your API requirements
            this.isUploading = true;

            const response = await this.axios.post(
              `${process.env.VUE_APP_BACKEND}/api/v1/file/public/image-upload`,
              formbody,
              {
                onUploadProgress: (progressEvent) => {
                  this.simulateProgressUpdate(progressEvent);
                },
              }
            );

            if (response && response.data) {
              const data = response.data.url[0];

              const uploadedImageData = {
                file_name: file.name || "default_filename", // Use the actual filename or a fallback
                file_path: data.file_path || "default_filepath", // Use the actual file path or a fallback
                file_url: data.file_url || "default_fileurl", // Use the actual file URL or a fallback
                type: "attached",
              };

              this.isUploading = false;
              this.uploadProgress = 0;

              this.businessMedia.img.push(uploadedImageData);
              this.$store.commit("onAlerting", {
                message_status: "อัปโหลดไฟล์สำเร็จ",
                color: "#58A144",
              });
            } else {
              console.error(
                "Failed to upload image: Response data is missing or malformed",
                response
              );
            }
          }

          if (this.businessMedia.img.length > 0) {
            await this.updateBusinessMedia({
              img: this.businessMedia.img,
              video: this.businessMedia.video,
            });

            await this.fetchBusinessMediaAdmin();
          }
        } catch (error) {
          console.error(
            "An error occurred during file upload:",
            error.response ? error.response.data.message : error.message
          );
        }
        this.isUploading = false;
        this.uploadProgress = 100;
      }

      event.target.value = null; // Reset the input value
    },

    async handleUploadedFiles(type, event) {
      const files = Array.from(event.target.files);
      this.filename = files[0].name;
      // เริ่มการอัปโหลด
      if (type === "video" && this.canUploadVideo && files.length > 0) {
        this.isUploadingVideo = true;
        this.uploadProgress = 0;

        // เช็คถ้ามีวิดีโออยู่แล้ว ไม่ให้อัปโหลดใหม่
        if (this.businessMedia.video.length > 0) {
          event.target.value = null;
          return;
        }

        // เช็คขนาดไฟล์
        for (const file of files) {
          if (file.size > 100 * 1024 * 1024) {
            // 100 MB
            // ส่งการแจ้งเตือนไปยัง Vuex store
            this.$store.commit("onAlerting", {
              message_status: "วิดีโอขนาดใหญ่เกิน 100MB ไม่สามารถอัปโหลดได้",
              color: "#D1392B",
            });
            this.isUploadingVideo = false;
            event.target.value = null;
            return;
          }

          try {
            let formbody = new FormData();
            formbody.append("file", file);

            const response = await this.axios.post(
              `${process.env.VUE_APP_BACKEND}/api/v1/file/public/video-upload`,
              formbody,
              {
                onUploadProgress: (progressEvent) => {
                  // คำนวณเปอร์เซ็นต์ความคืบหน้าของการอัปโหลด
                  this.uploadProgress = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  );
                },
              }
            );

            if (response && response.data) {
              const uploadedVideoData = {
                file_name: response.data.data.file_name,
                file_path: response.data.data.file_path,
                file_url: response.data.data.file_url,
                type: "attached",
              };

              // เก็บข้อมูลวิดีโอที่อัปโหลดใหม่ใน videoFilesList
              this.videoFilesList = [uploadedVideoData];
            } else {
              console.error("Failed to upload video:", response);
            }
          } catch (error) {
            console.error(
              "An error occurred during file upload:",
              error.response ? error.response.data.message : error.message
            );
          }
        }

        // อัปเดตข้อมูล media ของธุรกิจในระบบ
        if (this.videoFilesList.length > 0) {
          await this.updateBusinessMedia({
            video: this.videoFilesList,
            img: this.businessMedia.img,
          });

          // ดึงข้อมูล media ใหม่หลังอัปเดตเสร็จ
          await this.fetchBusinessMediaAdmin();
        }

        // สิ้นสุดการอัปโหลด
        this.isUploadingVideo = false;
        this.uploadProgress = 100; // แสดง 100% หลังจากการอัปโหลดสำเร็จหรือล้มเหลว
      }

      event.target.value = null; // รีเซ็ตค่า input file หลังการอัปโหลดเสร็จ
    },

    async handleDrop(type, event) {
      const files = Array.from(event.dataTransfer.files);

      if (type === "video") {
        await this.handleUploadedFiles(type, { target: { files } });
      } else if (type === "image") {
        await this.handleUploadedImage(type, { target: { files } });
      }
    },
    saveFilesToLocalStorage() {
      if (this.imageFilesList.length) {
        const images = this.imageFilesList.map((file) => this.path_file(file));
        localStorage.setItem("uploadedImages", JSON.stringify(images));
      } else {
        localStorage.removeItem("uploadedImages");
      }
      if (this.videoFilesList.length) {
        const videos = this.videoFilesList.map((file) => this.path_file(file));
        localStorage.setItem("uploadedVideos", JSON.stringify(videos));
      } else {
        localStorage.removeItem("uploadedVideos");
      }
    },

    // Load files from localStorage
    loadFilesFromLocalStorage() {
      const storedImages = JSON.parse(localStorage.getItem("uploadedImages"));
      const storedVideos = JSON.parse(localStorage.getItem("uploadedVideos"));

      if (storedImages) {
        this.imageFilesList = storedImages.map((src) => ({ src }));
      }
      if (storedVideos) {
        this.videoFilesList = storedVideos.map((src) => ({ src }));
      }
    },

    onDragEnter(type) {
      if (type === "image") this.isDraggingImage = true;
      if (type === "video") this.isDraggingVideo = true;
    },
    onDragLeave(type) {
      if (type === "image") this.isDraggingImage = false;
      if (type === "video") this.isDraggingVideo = false;
    },

    removeFile(index, type) {
      if (type === "video") {
        this.businessMedia.video.splice(index, 1); // Remove the video at the specified index
        this.updateBusinessMedia({
          video: this.businessMedia.video,
          img: this.businessMedia.img,
        });
      } else if (type === "image") {
        this.businessMedia.img.splice(index, 1); // Remove the image at the specified index
        this.updateBusinessMedia({
          video: this.businessMedia.video,
          img: this.businessMedia.img,
        });
      }
      // Optionally, you can also update the backend if necessary
      // await this.fetchBusinessMediaAdmin();
    },
    async handleUploadUrl() {
      try {
        if (this.videoUrl) {
          const uploadedVideoData = {
            file_name: "ลิงค์วิดิโอ", // Customize as needed
            file_path: "", // Possibly returned by the API
            file_url: this.videoUrl,
            type: "embedded",
          };
          this.videoFilesList = [uploadedVideoData];

          await this.updateBusinessMedia({
            video: this.videoFilesList,
            img: this.businessMedia.img,
          });
          this.videoUrl = ""; // Clear the input field
        } else {
          console.error("Failed to upload video URL:", this.videoUrl);
        }
      } catch (error) {
        console.error("Failed to upload video URL:", error);
      }
    },

    // API call to update business media
    async updateBusinessMedia(data) {
      try {
        const token = localStorage.getItem("token");
        const businessId = localStorage.getItem("business_id");
        const response = await this.axios.put(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/business-media/${businessId}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data && response.data.success) {
          this.fetchBusinessMediaAdmin();
        } else {
          console.error(
            "Failed to update business media:",
            response.data.message
          );
        }
      } catch (error) {
        console.error(
          "An error occurred while updating business media:",
          error.response ? error.response.data.message : error.message
        );
      }
    },
    async fetchBusinessMediaAdmin() {
      try {
        const token = localStorage.getItem("token");
        const businessId = localStorage.getItem("business_id"); // Retrieve the business_id

        const response = await this.axios.get(
          `${process.env.VUE_APP_BACKEND}/api/v1/entrepreneur_business/business-media/${businessId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Replace with your actual token
            },
          }
        );

        if (response.data.success) {
          const { img, video } = response.data.data;
          this.businessMedia.img = img || [];
          this.businessMedia.video = video || [];
        } else {
          this.errorMessage = response.data.message;
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data.message ||
          "An error occurred while fetching media.";
      }
    },
    backToProfile() {
      this.$router.push("/business_profile");
    },
  },
};
</script>

<style scoped>
.index-page {
  font-family: Noto Sans Thai !important;
}
.text-detail {
  font-size: 14px;
  color: #333333;
  line-height: 24px;
}
.text-file-lenght {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  width: 100%;
  padding: 1px;
  display: flex;
  justify-content: end;
}

.text-address {
  font-size: 18px;
  color: #4a4a4a;
  font-weight: 500;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-line;
  text-align: center;
}

.text-section {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
}

.v-card {
  background: #fff;
  border-radius: 8px;
}

.img-upload-field {
  border-radius: 8px;
  background-color: #cbd9d4;
  padding: 10px;
}

.header-style {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
}

.upload-area {
  text-align: center;
  background-color: white;
  border-radius: 8px;
  padding: 16px;
  border: 2px dashed var(--v-default_primary-base);
}

.upload-area:hover {
  background-color: var(--v-default_background_v2-base, #e7f5e6);
  border-radius: 8px;
  padding: 16px;
  border: 2px solid var(--v-default_primary-base);
  transition: all ease-out 0.5s;
}
.uploaded-files-list {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 16px;
}
.video-url-upload {
  align-items: start;
  background-color: white;
  border: 2px solid var(--v-default_primary-base);
  border-radius: 10px;
  height: 100%;
}
.btn-video-url-upload {
  color: var(--v-default_primary-base);
}
.btn-upload {
  background-color: white;
  color: var(--v-default_primary-base);
  border-radius: 30px;
  width: 140px;
  border: 2px solid var(--v-default_primary-base);
}
.btn-upload:hover {
  background-color: var(--v-default_primary-base);
  color: white;
  transition: all ease-out 0.3s;
}
.h2-responsive {
  font-size: 28px;
}

.btn-responsive {
  font-size: 14px;
  padding: 8px 16px;
}
.file-img {
  width: 40px;
  height: 40px;
}
.icon-hover:hover {
  background-color: #e0f5e8;
  color: #399e76;
}

.text-hover:hover {
  color: #399e76;
}
.border-box {
  border: 1px solid var(--v-default_primary-base);
  padding: 20px;
  border-radius: 4px;
}
.hovered-div:hover {
  background-color: #f5fff8;
}
.media-ratio {
  aspect-ratio: 16/9;
}

@media (max-width: 600px) {
  .h2-responsive {
    font-size: 16px;
  }

  .btn-responsive {
    font-size: 10px;
  }
}

.v-progress-linear {
  transition: width 0.4s ease; /* ควบคุม transition ให้แถบเคลื่อนไหวค่อยๆ */
}
</style>
